import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { loadOllieOpening } from 'src/features/OllieSlice'
import useOllieVenueId from 'src/hooks/useOllieVenueId'

const selectOpening = state => state.ollie.opening

/**
 * Ollie's opening message (findings → today's job → quiet day), plus the
 * Meet card / weekly brief when it's their moment. Call `load` when the
 * panel opens; Express answers from templates within a second.
 */
const useOllieOpening = () => {
  const dispatch = useDispatch()
  const { venueId } = useOllieVenueId()
  const opening = useSelector(selectOpening)
  const forVenue = opening.venueId === venueId

  const load = useCallback(
    (pageContext = '') =>
      venueId ? dispatch(loadOllieOpening({ venueId, pageContext })) : null,
    [dispatch, venueId],
  )

  return {
    status: forVenue ? opening.status : 'idle',
    opening: forVenue ? opening.data : null,
    error: forVenue ? opening.error : null,
    load,
  }
}

export default useOllieOpening
